/**
 * Purchase Cards Component
 * Handles functionality for One Time Purchase and HSA/FHA payment cards
 */

class PurchaseCards {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Handle HSA payment buttons (both links and buttons)
    // const hsaButtons = document.querySelectorAll('.hsa-payment-button');
    // hsaButtons.forEach(button => {
    //   if (button.tagName === 'A') {
    //     // It's a link, let it work normally but add analytics
    //     button.addEventListener('click', (event) => {
    //       this.handleHsaPaymentClick(button);
    //     });
    //   } else {
    //     // It's a button, prevent default and show message
    //     button.addEventListener('click', (event) => {
    //       event.preventDefault();
    //       this.handleHsaPaymentClick(button);
    //     });
    //   }
    // });

    // Note: Info buttons now use quantity-popover component
    // No need to handle them here anymore
  }


  handleHsaPaymentClick(button) {
    const href = button.href;
    
    if (href && href !== '#') {
      // It's a valid link, track the click and let it proceed
      this.trackHsaPaymentClick(button);
      return;
    }

    // No valid link, show message
    this.showMessage('HSA/FHA payment link is not configured. Please contact support.', 'info');
  }

  showMessage(message, type = 'info') {
    // Create or update message element
    let messageElement = document.querySelector('.purchase-cards-message');
    
    if (!messageElement) {
      messageElement = document.createElement('div');
      messageElement.className = 'purchase-cards-message';
      document.body.appendChild(messageElement);
    }

    // Set message content and type
    messageElement.textContent = message;
    messageElement.className = `purchase-cards-message purchase-cards-message--${type}`;
    messageElement.style.display = 'block';

    // Auto-hide after 5 seconds
    setTimeout(() => {
      messageElement.style.display = 'none';
    }, 5000);
  }

  trackHsaPaymentClick(button) {
    // Track HSA payment clicks for analytics
    console.log('HSA payment option clicked:', button.href);
    
    // You can add analytics tracking here
    // Example: gtag('event', 'hsa_payment_click', { 'link_url': button.href });
  }
}

// Make class globally available to prevent double loading
window.PurchaseCards = PurchaseCards;

// Initialize when DOM is ready (only if not already initialized)
if (!window.purchaseCardsInstance) {
  document.addEventListener('DOMContentLoaded', () => {
    window.purchaseCardsInstance = new PurchaseCards();
  });
}

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = PurchaseCards;
}
